import React from 'react';
import { useTranslation } from 'react-i18next';
import { LoadingPanel } from './LoadingPanel';

export const AnalyzingState: React.FC = () => {
  const { t } = useTranslation('dashboard');
  const tips = [
    t('create_job_modal.analyzing_tip_1'),
    t('create_job_modal.analyzing_tip_2'),
    t('create_job_modal.analyzing_tip_3'),
    t('create_job_modal.analyzing_tip_4'),
    t('create_job_modal.analyzing_tip_5'),
  ];
  return <LoadingPanel title={t('create_job_modal.one_moment')} tips={tips} />;
};
